window.addEventListener('load', () => {
    const url = window.location.href;
    const urlArr = url.split('/');
    if(urlArr.length == 4 && urlArr[3] == 'collections')

     {
        location.replace('/pages/collections');
    }
});

    
